"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackClient = exports.ZipDataEntry = exports.Environment = void 0;
const storage_blob_1 = require("@azure/storage-blob");
const feedback_client_api_1 = require("./generated/feedback-client-api");
const feedback_client_api_2 = require("./generated/feedback-client-api");
const FeedbackParamanters_1 = require("./models/FeedbackParamanters");
const crypto_es_1 = __importDefault(require("crypto-es"));
const jszip_1 = __importDefault(require("jszip"));
var Environment;
(function (Environment) {
    Environment["dev"] = "https://dfds-api.dev.doka.com";
    Environment["test"] = "https://dfds-api.test.doka.com";
    Environment["prod"] = "https://dfds-api.doka.com";
})(Environment = exports.Environment || (exports.Environment = {}));
class ZipDataEntry {
    constructor(entryName, data) {
        this._entryName = entryName;
        this._data = data;
    }
    get EntryName() {
        return this._entryName;
    }
    get Data() {
        return this._data;
    }
}
exports.ZipDataEntry = ZipDataEntry;
class FeedbackClient {
    constructor(basePath, token) {
        const t = token.startsWith("Bearer ") ? token : "Bearer " + token;
        const conf = new feedback_client_api_2.Configuration({ basePath: basePath, accessToken: t });
        this._client = new feedback_client_api_1.FeedbackApi(conf);
    }
    requestUploadAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._client.apiFeedbackRequestUploadPost();
        });
    }
    sendFeedbackAsync(feedbackText, applicationName, fileData) {
        return __awaiter(this, void 0, void 0, function* () {
            const blobTemplate = yield this.requestUploadAsync();
            const blobClient = new storage_blob_1.BlockBlobClient(blobTemplate.blobSas);
            if (blobClient) {
                yield blobClient.uploadData(fileData);
            }
            const hash = crypto_es_1.default.MD5(crypto_es_1.default.lib.WordArray.create(fileData));
            const md5 = hash.toString(crypto_es_1.default.enc.Hex);
            const feedbackParameters = new FeedbackParamanters_1.FeedbackParameters(feedbackText, applicationName, blobTemplate.blobName, fileData.byteLength, md5);
            return this._client.apiFeedbackSendFeedbackPost(feedbackParameters);
        });
    }
    createZip(dataEntries) {
        return __awaiter(this, void 0, void 0, function* () {
            const zip = new jszip_1.default();
            dataEntries.forEach(entry => {
                zip.file(entry.EntryName, entry.Data);
            });
            return zip.generateAsync({ type: "uint8array" });
        });
    }
}
exports.FeedbackClient = FeedbackClient;
